//Dependencies
require("common/com-scaffolding/com-scaffolding.chunk.js");
require("atomic/atom/a-embed-16by9/a-embed-16by9.chunk.js");

// Styles
require("./o-popup-youtube.scss");

// JavaScript
var $ = require("jquery");
var YoutubeIframeAPI = require("utils/youtube-iframe-api");

module.exports = function (opts) {

    // Options
    var options = $.extend({
        // Translation for the close label
        closeLabel: "Close",
        // Video Id
        videoId: "",
        // Random Id
        rndId: Math.floor(Math.random() * (9999 - 1111 + 1)) + 1111
    }, opts);

    // Variables
    var _self = this,
        $popup,
        ytPlayer,
        ytInit = false,
        isOpen = false;

    // Function that return jQuery object of the 
    // complete popup HTML to inject at the end 
    // of the body
    this.getHtml = function () {

        // Build HTML
        var html = "";
        html += '<div class="o-popup-youtube o-popup-youtube--loading">';
        html += '<div class="o-popup-youtube__overlay"></div>';
        html += '<button class="o-popup-youtube__close">' + options.closeLabel + '</button>';
        html += '<div class="o-popup-youtube__wrap">';
        html += '<div class="o-popup-youtube__outer">';
        html += '<div class="o-popup-youtube__inner">';
        html += '<div class="o-popup-youtube__player"><div class="a-embed-16by9"><div class="a-embed-16by9__item" id="o-popup-youtube-' + options.videoId + '-' + options.rndId + '"></div></div></div>';
        html += '</div>';
        html += '</div>';
        html += '</div>';
        html += '</div>';
        $popup = $(html);

        // Close event
        $('.o-popup-youtube__close', $popup).on('click.popup-youtube', function (e) {
            e.preventDefault();
            $popup.get(0).close(); // Close trough HtmlElement method
        });
        $('.o-popup-youtube__overlay', $popup).on('click.popup-youtube', function (e) {
            if (!_self.isFullpage()) {
                $popup.get(0).close(); // Close trough HtmlElement method
            }
        });

        // Return jQuery object of the popup HTML
        return $popup;
    },

        // Function that return a boolean indicating
        // in the page page content should be visible
        // during the popup display 
        // (used for fullpage display).
        this.isFullpage = function () {
            if ($popup.css('position') == 'fixed') {
                return false;
            }
            return true;
        },

        // Callback on popup DOM ready
        this.onDomReady = function () {
            // ...
        },

        // Callback on popup open
        this.onOpen = function () {
            isOpen = true;
            // Animation d'ouverture
            $popup.addClass('o-popup-youtube--show-step-1');
            window.requestAnimationFrame(function () {
                $popup.addClass('o-popup-youtube--show-step-2');
            });
            // Charger la vidéo si ce n'est pas déjà fait
            if (!ytInit) {
                ytInit = true;
                YoutubeIframeAPI({
                    onReady: function () {
                        ytPlayer = new YT.Player("o-popup-youtube-" + options.videoId + "-" + options.rndId, {
                            videoId: options.videoId,
                            events: {
                                'onReady': function () {
                                    $popup.removeClass("o-popup-youtube--loading");
                                    if (isOpen) {
                                        ytPlayer.playVideo();
                                    }
                                }
                            }
                        });
                    }
                });
            }
            // Démarrer la lecture du vidéo
            if (ytPlayer && ytPlayer.playVideo) {
                ytPlayer.playVideo();
            }
        },

        // Callback on popup close
        this.onClose = function () {
            isOpen = false;
            // Remove loading animation class
            // Doing this on close prevent visual glitch.
            $popup.removeClass("o-popup-youtube--loading");
            // Retraite des classes d'ouverture
            $popup.removeClass('o-popup-youtube--show-step-1');
            $popup.removeClass('o-popup-youtube--show-step-2');
            // Pauser la vidéo
            if (ytPlayer && ytPlayer.pauseVideo) {
                ytPlayer.pauseVideo();
            }
        }

};


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/organism/o-popup-youtube/o-popup-youtube.chunk.js